<script lang="ts">
  import type { UserLessonStore } from 'shared/src/user/userLessons/user.lesson.store';
  import { autorun } from 'mobx';
  import { onDestroy } from 'svelte';

  let clazz = '';
  export { clazz as class };

  export let lesson: UserLessonStore;
  export let lessonPage: UserLessonStore['pages'][number];

  let pages: {
    title: string;
    isAvailable: boolean;
    type: string;
    id: string;
  }[];
  let lessonTitle: string;
  const destroyer = autorun(() => {
    lessonTitle = lesson.title;
    pages = lesson.pages.map((page) => {
      return {
        title: page.title,
        isAvailable: page.isAvailable,
        type: page.type,
        id: page.id,
      };
    });
  });

  onDestroy(destroyer);
</script>

<div class={clazz}>
  <h1 class="text-slate-600 text-2lg font-bold pb-2">{lessonTitle}</h1>
  <ul>
    {#each pages as page}
      <li class:selected={page.id === lessonPage.id} class="py-1.5">
        {#if page.isAvailable}
          <a href={page.id} class="text-gray-700">
            {page.title}
            {#if page.type}<br /><span class="text-xs text-gray-light">{page.type}</span>{/if}
          </a>
        {:else}
          {page.title}
          {#if page.type}<br /><span class="text-xs text-gray-light">{page.type}</span>{/if}
        {/if}
      </li>
    {/each}
  </ul>
</div>

<style lang="postcss">
  li {
    @apply transition-colors duration-500 text-gray-light px-2 -ml-2;
  }
  li.selected {
    @apply bg-green;
    a,
    span {
      @apply text-white;
    }
  }
</style>
